import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./SelectMenuStyles";
import { activityActions } from "../_actions";
import moment from "moment";
import { activityDetailService } from "../_services";

export default class SelectMenuActivities extends Component {
  componentDidMount() {
    //if (this.props.energy.detail.details) this.props.dispatch(energyActions.setDetailItem(this.props.energy.detail.available[this.props.energy.detail.available.length-1]))
  }

  changeTime(e) {
    this.props.dispatch(activityActions.setDetailItem(e.target.value));
  }
  render() {
    let momentFormat,
      textFormat,
      momentAdjust,
      optionArray = [];

    const {
      activity: { detail, activityFrequency }
    } = this.props;

    if (activityFrequency === "day") {
      momentFormat = "dddd Do MMMM";
      textFormat = "Day";
      momentAdjust = null;
    } else if (activityFrequency === "week") {
      momentFormat = "Do MMMM";
      textFormat = "Week";
      momentAdjust = { day: 6 };
    }

    for (var i = detail.available.length - 1; i >= 0; i--) {
      optionArray.push(
        <option key={`selectItem${i}`} value={detail.available[i]}>
          {detail.available[i] === null
            ? "Last 7 days"
            : `${moment.unix(detail.available[i]).format(momentFormat)} ${
                momentAdjust ? "to" : ""
              } ${
                momentAdjust
                  ? moment
                      .unix(detail.available[i])
                      .add(momentAdjust)
                      .format(momentFormat)
                  : ""
              }`}
        </option>
      );
    }

    return (
      <div>
        <div className={css(styles.selectWrapper)}>
          <select
            className={css(styles.select)}
            value={this.props.activity.detailItem}
            onChange={e => this.changeTime(e)}
          >
            {optionArray}
          </select>
          <span className={css(styles.arrow)}>
            <span
              className={css(styles.changeText)}
            >{`Change ${textFormat}`}</span>
          </span>
        </div>
        <div className={css(styles.timeSelectWrapper)}>
          <button
            className={css(styles.timeButton)}
            disabled={detail.previous == null ? true : false}
            onClick={e =>
              this.props.dispatch(
                activityActions.setDetailItem(detail.previous)
              )
            }
          >
            <img
              className={css(styles.timeButtonIcon)}
              src={"/icons/previous.svg"}
            />
            {`Previous ${activityFrequency}`}
          </button>{" "}
          <button
            className={css(styles.timeButton)}
            disabled={detail.next == null ? true : false}
            onClick={e =>
              this.props.dispatch(activityActions.setDetailItem(detail.next))
            }
          >
            {`Next ${activityFrequency}`}
            <img
              className={css(styles.timeButtonIconRight)}
              src={"/icons/next.svg"}
            />
          </button>
        </div>
      </div>
    );
  }
}
